export const dimensions = {
  xs: { width: 320, height: 180 },
  sm: { width: 640, height: 360 },
  md: { width: 960, height: 540 },
  lg: { width: 1280, height: 720 },
  xl: { width: 1920, height: 1080 },
};
